import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios_instance from '../api/axios_instance';
import Cookies from 'js-cookie';

export const verifyAuth = createAsyncThunk('auth/verify', async (_, { rejectWithValue }) => {
  try {
    const res = await axios_instance.get('/api/auth/me', { timeout: 5000 });
    return res.data;
  } catch {
    return rejectWithValue(null);
  }
});

export const loginAdmin = createAsyncThunk('auth/login', async (credentials, { rejectWithValue }) => {
  try {
    const res = await axios_instance.post('/api/auth/login', credentials);
    Cookies.set('token', res.data.token, { expires: 7, sameSite: 'strict' });
    return res.data.admin;
  } catch (err) {
    return rejectWithValue(err.response?.data?.message || 'فشل تسجيل الدخول');
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    admin: null,
    isAuthenticated: false,
    loading: true,
    error: null,
  },
  reducers: {
    logout(state) {
      Cookies.remove('token');
      state.admin = null;
      state.isAuthenticated = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyAuth.pending,   (state) => { state.loading = true; })
      .addCase(verifyAuth.fulfilled, (state, action) => {
        state.admin = action.payload;
        state.isAuthenticated = true;
        state.loading = false;
      })
      .addCase(verifyAuth.rejected,  (state) => {
        state.admin = null;
        state.isAuthenticated = false;
        state.loading = false;
      })
      .addCase(loginAdmin.pending,   (state) => { state.loading = true; state.error = null; })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.admin = action.payload;
        state.isAuthenticated = true;
        state.loading = false;
        state.error = null;
      })
      .addCase(loginAdmin.rejected,  (state, action) => {
        state.admin = null;
        state.isAuthenticated = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
